import { styled } from '@linaria/react';

import { fonts, primitives, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: ${primitives.size['size-1000']};
  cursor: text;

  &:has(:disabled) {
    cursor: not-allowed;
  }

  &:has(select:enabled),
  &:has(button[aria-haspopup='listbox']:enabled) {
    cursor: pointer;
  }
`;

export const Label = styled.label<{ $error?: boolean }>`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${(p) => (p.$error ? semantic.text.danger : semantic.text.tertiary)};
  cursor: inherit;
`;

export const RequiredMark = styled.span`
  color: inherit;
`;

export const FieldError = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.danger};
  margin-top: ${space['space-200']};
`;
